<template>
    <ul class="pagination">
        <li v-if="pagination.current_page > 1">
            <a href="javascript:void(0)" aria-label="Previous" v-on:click.prevent="changePage(pagination.current_page - 1)">
                <span aria-hidden="true">«</span>
            </a>
        </li>
        <template v-if="pagesArray.length > 1">
            <li v-for="page in pagesArray" :class="{'active': page === pagination.current_page}">
                <a href="javascript:void(0)" v-on:click.prevent="changePage(page)">{{ page }}</a>
            </li>
        </template>
        <li v-if="pagination.current_page < pagination.last_page">
            <a href="javascript:void(0)" aria-label="Next" v-on:click.prevent="changePage(pagination.current_page + 1)">
                <span aria-hidden="true">»</span>
            </a>
        </li>
    </ul>
</template>
<script>
    export default{
        name: "FullPagination",
        props: {
            pagination: {
                type: Object,
                required: true
            },
            content: {
              type: Array,
            },
            offset: {
                type: Number,
                default: 4
            }
        },
        data: function () {
          return {
              pagesArray: []
          }
        },
        mounted: function () {
            this.refreshPages();
        },
        watch: {
            pagination : function () {
                this.refreshPages();
            }
        },
        methods : {

            refreshPages: function() {
                let pagesArray = [];

                if (!this.pagination.to) {
                    this.pagesArray =  [];
                }
                let from = this.pagination.current_page - this.offset;
                if (from < 1) {
                    from = 1;
                }
                let to = from + (this.offset * 2);
                if (to >= this.pagination.last_page) {
                    to = this.pagination.last_page;
                }
                for (let page = from; page <= to; page++) {
                    pagesArray.push(page);
                }

                this.pagesArray = pagesArray;
            },

            changePage(page) {
                this.$emit('paginate', page);
            }
        }
    }
</script>
